/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_P1Inputs */

const et_about_p1 = /** @type {(inputs: About_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me oleme Romet ja Marti. 7 aastat tagasi alustasime vabakutselistena, seejärel ehitasime kumbki üles oma edukad agentuurid. Täna oleme ScalingWebs.`)
};

const en_about_p1 = /** @type {(inputs: About_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We are Romet and Marti. 7 years ago, we started as freelancers, then each built successful agencies. Today, we are ScalingWebs.`)
};

/**
* | output |
* | --- |
* | "We are Romet and Marti. 7 years ago, we started as freelancers, then each built successful agencies. Today, we are ScalingWebs." |
*
* @param {About_P1Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const about_p1 = /** @type {((inputs?: About_P1Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_P1Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_about_p1(inputs)
	return en_about_p1(inputs)
});